import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';
import { type GetEnterpriseContractsParams, type EnterpriseContract } from 'types/enterprises';

export const useFetchEnterpriseContracts = (
  params?: GetEnterpriseContractsParams
): UseQueryResult<EnterpriseContract[]> => {
  const enterpriseId = useEnterpriseId();
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_CONTRACTS, enterpriseId, params],
    queryFn: () => EnterprisesService.getEnterpriseContracts(enterpriseId, params),
    select: response => response.data,
    enabled: !!enterpriseId,
    staleTime: FIFTEEN_MINUTES,
  });
};
